// actions.js
import * as actionTypes from "./actionsTypes";

export const setValuePCgps = (value) => ({
  type: actionTypes.SET_VALUE_PCGP,
  payload: value,
});

export const setTypePCgps = (type) => ({
  type: actionTypes.SET_TYPE_PCGP,
  payload: type,
});
export const setActifPCgps = (actif) => ({
  type: actionTypes.SET_ACTIF_PCGP,
  payload: actif,
});

export const setCurrentPagePCgps = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_PCGP,
  payload: page,
});

export const setOrderPCgps = (order) => ({
  type: actionTypes.SET_ORDER_PCGP,
  payload: order,
});

export const setSortFieldPCgps = (field) => ({
  type: actionTypes.SET_SORT_FIELD_PCGP,
  payload: field,
});
